import BillIcon from "@mui/icons-material/Receipt"

import { BillEdit, BillList, BillShow } from "./bills"
import { BillRefField } from "./fields/BillRefField"
import { BillRefInput } from "./inputs/BillRefInput"

const resource = {
  icon: BillIcon,
  list: BillList,
  show: BillShow,
  edit: BillEdit,
}

export {
  BillIcon,
  BillRefField,
  BillRefInput,
  // ActivityTitle,
  // ActivityFilter,
  // ActivityReferenceInput,
}

export * from "./inputs/DocumentTypeSelectInput"

export default resource
